// Helper function to format values (remove decimals except for EPS and add commas for large numbers)
export const formatValue = (value, type) => {
    if (value === null || value === "N/A") return ""; // Handle missing or null values

    const numValue = parseFloat(value);
    if (isNaN(numValue)) return "";

    if (type === "IQ_BASIC_EPS_INCL") {
        // Keep 2 decimal places for EPS
        return numValue.toFixed(2);
    } else {
        // Remove decimals and add commas for values > 3 digits
        return numValue.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
};


// Function to get the sorted values for a column
export const getSortedValuesForColumn = (columnType, competitors) => {
    return competitors
        .map((competitor) => {
            const value = parseFloat(
                competitor.data.find((item) => item.type === columnType)?.value || "N/A"
            );
            return { id: competitor._id, value };
        })
        .filter(({ value }) => !isNaN(value))
        .sort((a, b) => a.value - b.value); // Sort in ascending order
};


// Function to assign colors to each column based on sorted values
export const assignColorsToColumn = (columnType, competitors, sortedValues) => {
    const total = sortedValues.length;

    // If there are fewer than 4 valid values, we won't color them
    if (total < 4) return [];

    // Get the lowest (dark_red), second-lowest (light_red), second-highest (light_green), and highest (dark_green)
    const bottom = sortedValues[0]; // Dark Red
    const secondBottom = sortedValues[1]; // Light Red
    const secondTop = sortedValues[total - 2]; // Light Green
    const top = sortedValues[total - 1]; // Dark Green

    return sortedValues.map((entry) => {
        if (entry.id === bottom.id) {
            entry.color = "dark_red"; // Dark Red for the lowest
        } else if (entry.id === secondBottom.id) {
            entry.color = "light_red"; // Light Red for the second-lowest
        } else if (entry.id === secondTop.id) {
            entry.color = "light_green"; // Light Green for the second-highest
        } else if (entry.id === top.id) {
            entry.color = "dark_greeen"; // Dark Green for the highest
        } else {
            entry.color = "bg_white"; // Apply dark_white for all other entries
        }
        return entry;
    });
};   



export function ucfirst(str) {
  if (str === null || str === undefined) return '';
  const input = String(str);
  if (!input) return '';

  return input.charAt(0).toUpperCase() + input.slice(1);
}
